import { SvgIconComponent } from '@mui/icons-material';
import BusinessIcon from '@mui/icons-material/Business';
import ApiIcon from '@mui/icons-material/Api';
import EmailIcon from '@mui/icons-material/Email';
import TimelineIcon from '@mui/icons-material/Timeline';

/**
 * Dashboard Widget Configuration
 *
 * Represents a single widget card on the dashboard.
 */
export interface DashboardWidget {
  id: string;
  icon: SvgIconComponent;
  title: string;
  description: string;
  actionLabel: string;
  actionPath: string;
}

/**
 * Dashboard Section Configuration
 *
 * Groups related widgets under a common section heading.
 */
export interface DashboardSection {
  id: string;
  title: string;
  widgets: DashboardWidget[];
}

/**
 * Dashboard Sections Configuration
 *
 * Defines all dashboard sections and their widgets.
 * Navigation paths currently point to dashboard (placeholders until endpoints are defined).
 */
export const dashboardSections: DashboardSection[] = [
  {
    id: 'management',
    title: 'Management',
    widgets: [
      {
        id: 'accounts',
        icon: BusinessIcon,
        title: 'Accounts',
        description: 'Manage account organizations and their configurations',
        actionLabel: 'View Accounts',
        actionPath: '/accounts',
      },
    ],
  },
  {
    id: 'system',
    title: 'System',
    widgets: [
      {
        id: 'api-clients',
        icon: ApiIcon,
        title: 'API Clients',
        description: 'Manage API client credentials and access control',
        actionLabel: 'View Clients',
        actionPath: '/api-clients',
      },
      {
        id: 'messaging',
        icon: EmailIcon,
        title: 'Messaging',
        description: 'Monitor message queues and DLQ events',
        actionLabel: 'View Messages',
        actionPath: '/messaging',
      },
      {
        id: 'activity',
        icon: TimelineIcon,
        title: 'Activity',
        description: 'View domain events and system activity logs',
        actionLabel: 'View Activity',
        actionPath: '/dashboard',
      },
    ],
  },
];
